import './index.less';
import './fontawesome/css/font-awesome_4.5.0.min.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { createHashRouter, RouterProvider, Outlet, Navigate } from 'react-router';
import { getStore } from './store/storeSetup';
import touchy from './features/common/touchy';

import { selectPlatformByQuery, selectPlatformIdByQuery } from './features/common/platform/PlatformTools';

import * as queryUrl from './components/queryUrl';
import ControlCenterPage from './features/controlCenter/ControlCenterPage';
import MainLayout from './features/main/MainLayout';
import AppUrl from './features/appUrl/AppUrl';
import AppRemove from './features/appRemove/AppRemove';
import AppSettings from './features/appSettings/AppSettings';
import AppSuggestion from './features/appSuggestion/AppSuggestion';
import Sideload from './features/sideload/sideload';
import SideloadConfiguration from './features/sideloadConfiguration/sideloadConfiguration';
import AppsList from './features/appsList/AppsList';
import AppDetails from './features/appDetails/AppDetails';
import SessionLost from './features/user/SessionLost';

touchy();

const store = getStore();

store.dispatch(selectPlatformByQuery());
selectPlatformIdByQuery();

queryUrl.remove();

// Define routes configuration
const router = createHashRouter([
    {
        path: '/',
        element: (
            <DndProvider backend={HTML5Backend}>
                <MainLayout>
                    <AppUrl />
                    <AppRemove />
                    <AppSettings />
                    <AppSuggestion />
                    <Sideload />
                    <SideloadConfiguration />
                    <Outlet />
                </MainLayout>
                <SessionLost />
            </DndProvider>
        ),
        children: [
            {
                path: '',
                element: <Navigate to="apps" replace />,
            },
            {
                path: 'apps',
                element: <AppsList />,
            },
            {
                path: 'apps/:appId',
                element: <AppDetails />,
            },
            {
                path: 'control-center',
                element: <ControlCenterPage />,
            },
        ],
    },
]);

const root = ReactDOM.createRoot(document.getElementById('redux-app') as HTMLElement);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <RouterProvider router={router} />
        </Provider>
    </React.StrictMode>
);
